export default __webpack_public_path__ + "static/media/Nerd_NINJAI.239be9e9.png";